// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2SKEX","buttons":"PendingPaymentAlert_buttons__2B1yp"};